export const Card = ({ className = "", children }) => (
  <div className={`rounded-2xl p-4 shadow-md ${className}`}>{children}</div>
);
export const CardContent = ({ className = "", children }) => (
  <div className={className}>{children}</div>
);
